import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'app-supplier-cell-renderer',
    templateUrl: './supplier-cell-renderer.component.html',
    styleUrls: ['./supplier-cell-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class SupplierCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  supplierCodes: string;
  openDlgBox: boolean = true;

  constructor(private readonly dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
    // Parse into array, pad zeros
    this.supplierCodes = params.value.substring(0,20) ;
    if(params.value.length <= 19){
      this.openDlgBox = false;
    }else{
      this.supplierCodes = this.supplierCodes + "..."
    }
    
   
  }

  refresh(): boolean { return false; }

  openDialog(): void {
    if(!this.openDlgBox)
      {return;}
    this.dialog.open(DialogComponent, {
      width: '600px', // ⬅️ Adjust as needed (e.g., 300px or 50%)
      maxHeight: '400px',
      data: {
        title: 'Supplier Codes',  // Set title here
        message: this.params.value,
        buttonText: { cancel: 'Close' }
      }
    });
  }
  
}
